import React, { forwardRef, useContext, useEffect, useImperativeHandle, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { CreateArtifactContext } from "../../../../context/CreateArtifactContext";
import {
  SKArtifact,
  SKDocumentArtifact,
  SKPlaceArtifact,
  ContentState,
  getArtefactIcon,
  getContentCreatorActionableItems,
  ContentSubstate,
  TopicTypeString,
} from "../../../../models/SKArtifact";
import { useNavigationBar } from "../../../../context/NavigationContext";
import { capitalizeFirstLetter } from "../../../../utils/stringFunctions";
import { ChoosePublishingSequence } from "./components/ChoosePublishingSequence";
import { ChoosePublishingTier } from "./components/ChoosePublishingTier";
import { AddContentItem } from "./components/AddContentItem";
import { CertifyArtifact } from "./components/CertifyArtifact";
import ArtifactAgeRating from "./components/ArtifactAgeRating";
import ArtifactTopics from "./components/ArtifactTopics";
// import { AddTextAreaField } from "./components/AddTextAreaField";
import ImageInput from "../ImageInput";
import { AllMediaInput } from "./components/AllMediaInput";
import { ContentStatusView } from "./components/ContentStatusView";
import ContentHistoryNavigator from "./components/ContentHistoryNavigator";
import { ArtifactContainerRef } from "./CreateArtifact";
import ContentEditNavigator from "../../../contentModeration/ContentEditNavigator";
import { AddTextField } from "../../../../components/AddTextField";
import { AddTextAreaField } from "../../../../components/AddTextAreaField";
import ContextCheckListCard from "./components/ContextCheckListCard";
import { PublishingTier } from "./components/PublishingTier";
import ContentReportNavigator from "./components/ContentReportNavigator";
import { useAuth, UserRole } from "../../../../context/AuthContext";
import { FolderName } from "../../../../api/shared/uploadService";
const PlaceArtifactContainer = forwardRef<ArtifactContainerRef>((props, ref) => {
  const [coverImage, setCoverImage] = useState<string>("");
  const [isValidForm, setIsValidForm] = useState(false);
  const context = useAuth();
  const { contentData, updateContentData, artifactId, isModerator, isContentEditing, isEditable } = useContext(CreateArtifactContext);

  const [error, setErrorState] = useState<{ [key: string]: string | undefined }>({});

  const setErrors = (newErrors: { [key: string]: string | undefined }) => {
    setErrorState(newErrors);
  };

  useImperativeHandle(ref, () => ({
    containerSchema: () => schema,
    setErrors: newErrors => setErrors(newErrors),
  }));

  useEffect(() => {}, []);
  const navigate = useNavigate();
  const { setNavProps } = useNavigationBar();

  const schema = Yup.object().shape({
    type: Yup.string().required(),
    title: Yup.string().required().max(50),
    subtitle: Yup.string().notRequired().max(500),
    text: Yup.string().notRequired().max(500),
    topic: Yup.string().required(),
    tier: Yup.string().required(),
    age: Yup.number().required(),
    status: Yup.string().required(),
    coverMedia: Yup.object({
      coverImageURL: Yup.string().required("Cover image is required"),
      coverVideoURL: Yup.string().notRequired(),
      coverAudioURL: Yup.string().notRequired(),
    }).required("Cover media is required"),
    certifyFirst: Yup.boolean().oneOf([true]).required("Please certify content"),
    certifySecond: Yup.boolean().oneOf([true]).required("Please certify content"),
    // autoPublish: Yup.boolean().required(),
    location: Yup.object({
      latitude: Yup.number().required("Latitude is required"),
      longitude: Yup.number().required("Longitude is required"),
      title: Yup.string().required("Title is required"),
      address: Yup.string().required("Address is required"),
      url: Yup.string().notRequired(),
    }).required(),
    placeDescription: Yup.string().required(),
  });

  // address: Yup.string().required(),
  // placeName: Yup.string().required(),
  // placeAddress: Yup.string().required(),
  // placeDescription: Yup.string().required(),
  // useEffect(() => {
  //   const validate = async () => {
  //     try {
  //       await schema.validate(contentData, { abortEarly: false });
  //       setIsValidForm(true);
  //     } catch (err) {
  //       setIsValidForm(false);
  //     }
  //   };
  //   validate();
  // }, [contentData, schema]);

  const handleImageChange = (index: number, fileUrl: string | null) => {
    setCoverImage(fileUrl ?? "");
    updateContentData({ coverMedia: { ...contentData.coverMedia, coverImageURL: fileUrl! } });
  };

  return (
    <>
      <div className="flex flex-col gap-[30px] mt-[10px]">
        {isModerator &&
        !isContentEditing &&
        artifactId &&
        contentData.status === ContentState.ACTIVE &&
        contentData.subStatus === ContentSubstate.EDIT_IN_REVIEW ? (
          <ContentEditNavigator title="Channel Edit" docId={artifactId!} />
        ) : (
          ""
        )}

        {artifactId && (contentData as SKArtifact).hasHistory ? <ContentHistoryNavigator title="Channel Status" contentId={artifactId} /> : ""}
        {artifactId && context?.userRoles?.includes(UserRole.SkarvoAdmin) && contentData.reportCount && contentData.reportCount > 0 ? (
          <ContentReportNavigator title="Content Reports" />
        ) : (
          ""
        )}
        <AddContentItem
          index={1}
          onClick={() => {
            navigate("addPlace");
          }}
          count={(contentData as SKPlaceArtifact)?.location ? 1 : 0}
        />

        <AddTextField
          name={"addtitle"}
          title={"Add Title"}
          note={"Title can be the subject, purpose, theme or topic of your post."}
          placeholder={"Enter Title"}
          index={2}
          charAllowed={100}
          value={(contentData as SKArtifact).title}
          onChange={async e => {
            updateContentData({ title: e.target.value! });
          }}
          disabled={!isEditable}
          error={error?.title}
        />

        <AddTextAreaField
          name={"addtext"}
          title={"Add Text"}
          note={"Maximum text length of 500 characters."}
          placeholder={"Enter Text"}
          index={3}
          height={150}
          charAllowed={500}
          value={(contentData as SKArtifact).subtitle as string}
          onChange={async e => {
            updateContentData({ subtitle: e.target.value! });
          }}
          disabled={!isEditable}
          error={error?.text}
        />

        {artifactId ? (
          <>
            {/* cover image Upload */}
            <div>
              <div className="relative w-full min-w-[200px]">
                <div className="flex items-center">
                  <span>
                    <span className="content_count">4</span>
                  </span>
                  <span className="content_title">Add Cover Photo</span>
                </div>
                <div className="notes-class-content">
                  Choose a photo that represents the topic, purpose or title of the post. Recommended aspect ratio of photo is either 4:3, 1:1, or
                  3:4.
                </div>
              </div>
              <div>
                <ImageInput
                  key={0}
                  index={4}
                  onFileChange={handleImageChange}
                  docId={artifactId!}
                  maxFileSize={10}
                  imageUrl={contentData.coverMedia?.coverImageURL}
                  editable={isEditable}
                  folder={FolderName.content}
                />
              </div>
            </div>
            {/* cover media Upload */}
            <AllMediaInput
              name={"Add Cover Video or Audio"}
              index={5}
              note={"Choose a video or audio that represents the topic, purpose or title of the post."}
              docId={(contentData as SKDocumentArtifact).id}
              isEditable={isEditable}
            />
          </>
        ) : (
          <></>
        )}

        <ContextCheckListCard
          index={6}
          name="Add Topic"
          title="Choose the primary topic of your Content."
          purposeText="Add Topic"
          notes="Choose the topic that represents the primary focus of most of your Content."
          doneText={contentData.topic ? capitalizeFirstLetter(TopicTypeString[contentData.topic]) : undefined}
          action={() => {
            navigate("selectTopic");
          }}
          disabled={!isEditable}
        />

        <ContextCheckListCard
          index={7}
          name="Add Age Rating"
          title="Choose the Age Rating of your Content"
          purposeText="Add Age Rating"
          notes="Choose the age rating based on the appropriateness of your Content for children."
          doneText={contentData.age ? "Age " + contentData.age + "+" : undefined}
          action={() => {
            navigate("ageRating");
          }}
          disabled={!isEditable}
        />

        <ContextCheckListCard
          index={8}
          name="Certify Content"
          title="Certify Content"
          purposeText="Certify Content"
          notes="Certify that your Content would ensure and comply with these requirements."
          doneText={contentData.certifyFirst && contentData.certifySecond ? "Certified" : undefined}
          action={() => {
            navigate("certifyContent");
          }}
          disabled={!isEditable}
        />
        <PublishingTier index={9} />
        {/* <ChoosePublishingSequence index={10} /> */}
      </div>
    </>
  );
});
export default PlaceArtifactContainer;
